import { Component } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash-es'
import classnames from 'classnames'
import TimetoastPropTypes from '@constants/timetoast_prop_types.js'
import Status from '@constants/request_statuses.ts'
import CommentsList from './CommentsList.jsx'
import NewCommentForm from './NewCommentForm.jsx'
import HorizontalSpinner from '@components/HorizontalSpinner.tsx'
import Button from '@components/Button.tsx'

export default class TimelineComments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expandStatus: 'collapsed',
      minDelayComplete: false,
    }
  }

  handleLoadCommentsClick = event => {
    event.preventDefault()
    const { timelineId, onClickLoadComments } = this.props
    onClickLoadComments(timelineId)
    setTimeout(() => {
      this.setState({
        minDelayComplete: true,
      })
    }, 400)
    this.setState({ expandStatus: 'expanded' })
  }

  getCommentsContent() {
    const { status, comments } = this.props
    const { expandStatus, minDelayComplete } = this.state
    if (expandStatus === 'expanded') {
      if (minDelayComplete) {
        switch (status) {
          case Status.FAILED:
            return <div className="timeline-comments__failed-to-load">Failed to load comments</div>

          case Status.SUCCEEDED: {
            const commentForm = this.getNewCommentFormContent()
            return (
              <div>
                <CommentsList comments={comments} />
                {commentForm}
              </div>
            )
          }
        }
      }
      return (
        <div className="timeline-comments__progress-indicator">
          <HorizontalSpinner />
        </div>
      )
    }
    return null
  }

  getLoadCommentsButtonContent() {
    const { status } = this.props
    if (status === Status.IDLE) {
      return (
        <Button
          onClick={this.handleLoadCommentsClick}
          className="timeline-comments__load-comments p"
          title="Show this timeline's comments"
        >
          Show comments
        </Button>
      )
    }
    return null
  }

  getNewCommentFormContent() {
    const { canComment, createCommentPath } = this.props
    if (canComment) {
      return <NewCommentForm path={createCommentPath} />
    }
    return null
  }

  render() {
    const { expandStatus } = this.state
    const loadCommentsButton = this.getLoadCommentsButtonContent()
    const comments = this.getCommentsContent()
    const className = classnames('timeline-comments', { p: expandStatus === 'expanded' })
    return (
      <div className={className}>
        {loadCommentsButton}
        {comments}
      </div>
    )
  }
}
TimelineComments.propTypes = {
  timelineId: PropTypes.number.isRequired,
  onClickLoadComments: PropTypes.func.isRequired,
  comments: PropTypes.object.isRequired,
  canComment: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  error: TimetoastPropTypes.serializableError,
}
TimelineComments.defaultProps = {
  onClickLoadComments: noop,
  comments: {},
  canComment: false,
}
